import { render, staticRenderFns } from "./planoCurricularNovo.vue?vue&type=template&id=faf4feee&scoped=true&"
import script from "./planoCurricularNovo.vue?vue&type=script&lang=js&"
export * from "./planoCurricularNovo.vue?vue&type=script&lang=js&"
import style0 from "./planoCurricularNovo.vue?vue&type=style&index=0&id=faf4feee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf4feee",
  null
  
)

export default component.exports